import React from 'react';

import { getAPI } from '../utils/APIUtils';
import { downloadData } from 'aws-amplify/storage';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { PubContents } from '../states/appState';

type Props = {
  open: boolean;
  pubContents: PubContents[];
  accountid: string;
  idid: string;
  handleClose: () => void;
  handleOk: () => void;
  setLoading: (loading: boolean) => void;
};

export const PubContentsDialog: React.FC<Props> = (props) => {

  const handleDownload = async (type) => {
    try {
      props.setLoading(true);
      const url1 = `/pubcontents/download?key=${props.pubContents[type].key}&idid=${props.idid}`;
      const json = await getAPI(url1);
      const tmp: string = json.outPath;
      const newOutPath = tmp.replace(/private\/.*?\//, '');
      if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
        downloadFormLGWAN(newOutPath);
      } else {
        downloadForm(newOutPath);
      }

    } catch (e) {
      // エラー
      console.log(e);
    }

  };

  const downloadFormLGWAN = async (path: string) => {
    const apiurl = `/tempfile?path=private/${props.idid}/${path}`;
    const json = await getAPI(apiurl);
    const realdownloadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.downloadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.downloadUrl;

    const file = await fetch(realdownloadurl);
    const blob = await file.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = path.split('/').pop();
    link.setAttribute('download', filename ? filename : 'noname');
    document.body.appendChild(link);
    link.click();
    props.setLoading(false);
  };

  const downloadForm = async (path: string) => {
    const downloadTask = await downloadData({
      path: `private/${props.idid}/${path}`,
    });
    const { body } = await downloadTask.result;
    const blob = new Blob([await body.blob()]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    const filename = path.split('/').pop();
    link.setAttribute('download', filename ? filename : 'noname');
    document.body.appendChild(link);
    link.click();
    props.setLoading(false);
  };

  const createContents = () => {
    const createLimited = () => {
      return props.pubContents[1].key ? (
        <Paper sx={{
          minWidth: 500,
          margin: (theme) => theme.spacing(1),
          padding: (theme) => theme.spacing(1),
        }} elevation={3}>
          <Typography sx={{ margin: 1, }} variant="body1" gutterBottom>
            作成日時：{props.pubContents[1].date}
          </Typography>
          <Typography sx={{ margin: 1, }} variant="body1" gutterBottom>
            作成タイプ：{props.pubContents[1].executeMode === 'limited' ? '外部公開版(外部公開設定された文書のみ)' : '全文書版(外部非公開設定された文書も含めた全文書)'}
          </Typography>
          <Button onClick={() => handleDownload(1)} color="primary">
            ダウンロード
          </Button>
        </Paper>
      ) : (
        <Paper sx={{
          minWidth: 500,
          margin: (theme) => theme.spacing(1),
          padding: (theme) => theme.spacing(1),
        }} elevation={3}>
          <Typography sx={{ margin: 1, }} variant="body1" gutterBottom>
            ダウンロード可能な外部公開版(外部公開設定された文書のみ)コンテンツは存在しません。
          </Typography>
        </Paper>
      );
    };
    const createUnlimited = () => {
      return props.pubContents[0].key ? (
        <Paper sx={{
          minWidth: 500,
          margin: (theme) => theme.spacing(1),
          padding: (theme) => theme.spacing(1),
        }} elevation={3}>
          <Typography sx={{ margin: 1, }} variant="body1" gutterBottom>
            作成日時：{props.pubContents[0].date}
          </Typography>
          <Typography sx={{ margin: 1, }} variant="body1" gutterBottom>
            作成タイプ：{props.pubContents[0].executeMode === 'limited' ? '外部公開版(外部公開設定された文書のみ)' : '全文書版(外部非公開設定された文書も含めた全文書)'}
          </Typography>
          <Button onClick={() => handleDownload(0)} color="primary">
            ダウンロード
          </Button>
        </Paper>
      ) : (
        <Paper sx={{
          minWidth: 500,
          margin: (theme) => theme.spacing(1),
          padding: (theme) => theme.spacing(1),
        }} elevation={3}>
          <Typography sx={{ margin: 1, }} variant="body1" gutterBottom>
            ダウンロード可能な全文書版(外部非公開設定された文書も含めた全文書)コンテンツは存在しません。
          </Typography>
        </Paper>
      );
    };
    return props.pubContents.length === 2 ? (
      <>
        {createUnlimited()}
        {createLimited()}
      </>
    ) : (
      <Paper sx={{
        minWidth: 500,
        margin: (theme) => theme.spacing(1),
        padding: (theme) => theme.spacing(1),
      }} elevation={3}>
        <Typography sx={{ margin: 1, }} variant="body1" gutterBottom>
          ダウンロード対象のコンテンツが存在しません。
        </Typography>
      </Paper>
    );
  };

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"外部公開コンテンツダウンロード"}</DialogTitle>
      <DialogContent sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
          margin: (theme) => theme.spacing(1),
        },
      }}>
        {createContents()}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog >
  );

};